import {useState, useEffect, useRef} from "react";
import {useStore} from "./useStore";

export const useFetch = ({
    fetchFn,
    dependencies = [],
    condition = true,
    defaultDataValue = [],
    showLoading = false,
    initialCall = true,
    callbackFunc = () => {},
    waitForResponse = false,
    transform
}) => {
    const stores = useStore();
    const didMount = useRef(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(defaultDataValue);

    useEffect(() => {
        const fetchData = async () => {
            if (waitForResponse && loading) return;
            setLoading(true);
            let result;
            const res = fetchFn?.();

            if (res instanceof Promise) {
                result = await res.then(r => transform ? transform(r) : r);
            } else {
                result = transform ? transform(res) : res;
            }
            callbackFunc(result);
            setLoading(false);
            setData(result);
        };

        if (condition && (initialCall || didMount.current)) fetchData();
        else didMount.current = true;
    }, dependencies);

    useEffect(
        () => {
            stores.appStore.setLoading(loading);
        },
        showLoading ? [loading] : []
    );

    const refetch = async () => {
        if (waitForResponse && loading) return;
        setLoading(true);
        const result = await fetchFn();
        callbackFunc(result);
        setLoading(false);
        setData(result);
    };

    return [loading, data, setData, setLoading, refetch];
};
